var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex -md:flex-col -md:items-start -md:gap-y-3 md:justify-end md:gap-x-4 px-3 md:px-5 mb-24 md:mb-48 mt-3 md:mt-5"},_vm._l((_vm.buttons),function(item){return _c('AtomButton',{key:item.title,staticClass:"btn-sm",attrs:{"tag":"a","href":item.link}},[_vm._v(_vm._s(item.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }